import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { StateService } from '@ninety/platform/services/services/state.service';
import { selectCurrentUserEffectiveTimezone } from '@ninety/platform/state';
import { NotificationActions } from '@ninety/platform/state/app-global/notifications/notification.actions';
import { EFFECTIVE_TIMEZONE, INVALID_DUE_DATE_NOTIFIER, InvalidDueDateNotifier, LOCALE_STREAM } from '@ninety/ui/core';

/**
 * Binds the tokens consumed by `InlineEditableDueDateComponent` in `@ninety/ui/core` to their
 * `platform`-backed implementations: the invalid-date notification (`platform/state`) and the locale
 * stream (`StateService`). The component stays free of any `@ninety/platform/state` and
 * `@ninety/platform/services` dependency so it can be packaged in the public API; this composition-root
 * wiring is the single place that depends on both the tokens and those platform libs. (DEV-26530 6a)
 */
export const INLINE_EDITABLE_DUE_DATE_PROVIDERS: Provider[] = [
  {
    provide: INVALID_DUE_DATE_NOTIFIER,
    useFactory:
      (store: Store): InvalidDueDateNotifier =>
      message =>
        store.dispatch(NotificationActions.notifyV2({ message, params: { config: { duration: 3000 } } })),
    deps: [Store],
  },
  {
    provide: LOCALE_STREAM,
    useFactory: (stateService: StateService) => stateService.localeChange$,
    deps: [StateService],
  },
  {
    provide: EFFECTIVE_TIMEZONE,
    useFactory: (store: Store) => store.selectSignal(selectCurrentUserEffectiveTimezone),
    deps: [Store],
  },
];
